import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import FormModal from 'flarum/common/components/FormModal';
import Switch from 'flarum/common/components/Switch';
import DiscussionSearch from 'ext:sycho/flarum-uikit/forum/components/DiscussionSearch';
import GlobalSearchState from 'flarum/forum/states/GlobalSearchState';
export default class MovePostsModal extends FormModal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "isLoading", false);
    _defineProperty(this, "newDiscussion", false);
    _defineProperty(this, "newDiscussionTitle", '');
    _defineProperty(this, "targetDiscussionId", null);
    _defineProperty(this, "search", new GlobalSearchState());
  }
  className() {
    return 'MovePostsModal';
  }
  title() {
    return app.translator.trans('sycho-move-posts.forum.modal.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("form", {
      className: "Form",
      onsubmit: this.onsubmit.bind(this)
    }, m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('sycho-move-posts.forum.modal.selected_posts', {
      count: this.attrs.postIds.length
    })), m("input", {
      className: "FormControl",
      readonly: true,
      value: this.attrs.postIds.join(', ')
    })), m("div", {
      className: "Form-group"
    }, m(Switch, {
      state: this.newDiscussion,
      onchange: () => this.newDiscussion = !this.newDiscussion
    }, app.translator.trans('sycho-move-posts.forum.modal.new_discussion'))), this.newDiscussion ? m("div", {
      className: "Form-group"
    }, m("label", {
      for: "discussion_name"
    }, app.translator.trans('sycho-move-posts.forum.modal.discussion_name')), m("p", {
      className: "helptext"
    }, app.translator.trans('sycho-move-posts.forum.modal.discussion_help')), m("input", {
      id: "discussion_name",
      className: "FormControl",
      required: true,
      oninput: e => this.newDiscussionTitle = e.target.value
    })) : m("div", {
      className: "Form-group"
    }, m("label", {
      for: "destination"
    }, app.translator.trans('sycho-move-posts.forum.modal.destination')), m(DiscussionSearch, {
      state: this.search,
      ignore: this.attrs.discussion.id(),
      onSelect: discussion => this.targetDiscussionId = discussion.id()
    })), m("div", {
      className: "Form-group Form-controls"
    }, m(Button, {
      className: "Button Button--primary",
      type: "submit",
      loading: this.isLoading === 'submit',
      disabled: this.isLoading === 'check' || !this.targetDiscussionId && !this.newDiscussionTitle
    }, app.translator.trans('sycho-move-posts.forum.modal.submit')), m(Button, {
      className: "Button",
      onclick: this.emulate.bind(this),
      loading: this.isLoading === 'check',
      disabled: this.isLoading === 'submit' || !this.targetDiscussionId && !this.newDiscussionTitle
    }, app.translator.trans('sycho-move-posts.forum.modal.check')))));
  }
  data() {
    const data = {
      sourceDiscussionId: this.attrs.discussion.id(),
      postIds: this.attrs.postIds
    };
    if (this.newDiscussion) {
      data.newDiscussion = true;
      data.newDiscussionTitle = this.newDiscussionTitle;
    } else {
      data.targetDiscussionId = this.targetDiscussionId;
    }
    return data;
  }
  emulate() {
    this.onsubmit(null, true).then(response => {
      switch (response.status) {
        case 'old_to_new_move':
          this.alertAttrs = {
            type: 'error',
            content: app.translator.trans('sycho-move-posts.forum.modal.status.old_to_new_move')
          };
          break;
        case 'simple_move':
          this.alertAttrs = {
            type: 'success',
            content: app.translator.trans('sycho-move-posts.forum.modal.status.simple_move')
          };
          break;
        case 'complex_move':
          this.alertAttrs = {
            type: 'warning',
            content: app.translator.trans('sycho-move-posts.forum.modal.status.complex_move')
          };
          break;
        default:
          break;
      }
      m.redraw();
    });
  }
  onsubmit(e, emulate) {
    if (e) e.preventDefault();
    this.isLoading = emulate ? 'check' : 'submit';
    let url = '/api/posts/move';
    if (emulate) url += '/check';
    return app.request({
      method: 'POST',
      url: "".concat(app.forum.attribute('baseUrl')).concat(url),
      body: {
        data: this.data()
      },
      errorHandler: e => {
        const error = e.response.errors[0];
        this.isLoading = false;
        if (error.code !== 'move_old_post_to_newer_discussion') {
          throw e;
        }
        this.alertAttrs = {
          type: 'error',
          content: app.translator.trans('sycho-move-posts.forum.error.move_old_post_to_newer_discussion')
        };
        m.redraw();
      }
    }).then(response => {
      this.isLoading = false;
      if (!emulate) {
        m.redraw();
        window.location.reload();
        app.modal.close();
      }
      return response;
    });
  }
}
flarum.reg.add('sycho-move-posts', 'forum/components/MovePostsModal', MovePostsModal);